import _ from 'lodash';
import { createSelector } from 'reselect';
import { State } from '../../../types';
import { WaiverWorkItemUpdateStatus } from './waiverWorkItemUpdateStatusReducer';
import { selectErrorMessage as selectEntityUpdateErrorMessage } from '../../../entities/waivers/workItems/waiverWorkItemDetailsSelectors';

function selectRoot(state: State): WaiverWorkItemUpdateStatus {
  return state.components.waivers.workItem.updateState;
}

export const selectUpdateEventStatus = createSelector(
  [selectRoot, selectEntityUpdateErrorMessage],
  (updateEventStatus: WaiverWorkItemUpdateStatus, updateErrorMessage: string | null) =>
    updateErrorMessage ? {
      ...updateEventStatus,
      statusMessage: {
        success: false,
        message: updateErrorMessage
      }
    } : updateEventStatus
);

export const selectUpdatePending = createSelector(
  [selectUpdateEventStatus],
  (updateEventStatus: WaiverWorkItemUpdateStatus) => updateEventStatus.pending
);

export const selectUpdateSuccess = createSelector(
  [selectUpdateEventStatus],
  (updateEventStatus: WaiverWorkItemUpdateStatus) => _.get(updateEventStatus.statusMessage, 'success')
);

export const selectUpdateMessage = createSelector(
  [selectUpdateEventStatus],
  (updateEventStatus: WaiverWorkItemUpdateStatus) => _.get(updateEventStatus.statusMessage, 'message')
);